import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  prices: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column', 
      alignItems: 'center', 
    },
  },
  currencyField: {
    maxWidth: '145px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      margin: '0 0 20px ' 
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px', 
      marginTop: '20px', 
    },
  },
  timeSection:{
    margin:'20px 0'
  },
  timePicker :{
     maxWidth: '145px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      margin: '0 0 20px ' 
    },
  },
  hoursSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '23px',
    margin: '20px 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  }
}));